import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { BuilderStatisticsService } from './builder-statistics.service';
import { JobStatistics } from './entities';
import { StatisticsDetailsModule } from './ui-statistics-details/index';

@Component({
    selector: 'app-builder-statistics',
    templateUrl: './builder-statistics.component.html',
    styleUrls: ['./builder-statistics.component.scss'],
    standalone: false,
})
export class BuilderStatisticsComponent implements OnChanges {
    // @ts-ignore TS2564
    @Input() clientId: string;
    // @ts-ignore TS2564
    public jobStatistics$: Observable<JobStatistics>;
    constructor(private readonly builderStatisticsService: BuilderStatisticsService) {}
    ngOnChanges(changes: SimpleChanges): void {
        // @ts-ignore TS2532
        if (changes.clientId.isFirstChange() || changes.clientId.currentValue !== changes.clientId.previousValue) {
            this.jobStatistics$ = this.builderStatisticsService.getJobStatisticsById(this.clientId);
        }
    }
}

@NgModule({
    declarations: [BuilderStatisticsComponent],
    imports: [CommonModule, StatisticsDetailsModule],
    exports: [BuilderStatisticsComponent],
})
export class BuilderStatisticsModule {}
